import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';
import { AutoScrollContainer } from './components';
import { getScroll } from './helpers';
import { SCROLL_DIRECTION, SCROLL_BEHAVIOR } from './constants';

export const AutoScroll = ({
  speed, scrollBehavior, children, ...rest
}) => {
  let scrollHandler = null;
  const autoScrollRef = useRef();

  const onUpperBoundryIntersection = useCallback(() => {
    if (
      [SCROLL_BEHAVIOR.OSCILLATE, SCROLL_BEHAVIOR.DOWN].includes(scrollBehavior)
    ) {
      clearInterval(scrollHandler);
      const scroll = getScroll(
        autoScrollRef.current,
        speed,
        SCROLL_DIRECTION.DOWN
      );
      scrollHandler = scroll();
    }
  }, [
    SCROLL_DIRECTION.DOWN,
    SCROLL_BEHAVIOR.OSCILLATE,
    SCROLL_BEHAVIOR.DOWN,
    scrollHandler,
    scrollBehavior,
    speed,
  ]);

  const onLowerBoundryIntersection = useCallback(() => {
    if (
      [SCROLL_BEHAVIOR.OSCILLATE, SCROLL_BEHAVIOR.UP].includes(scrollBehavior)
    ) {
      clearInterval(scrollHandler);
      const scroll = getScroll(
        autoScrollRef.current,
        speed,
        SCROLL_DIRECTION.UP
      );
      scrollHandler = scroll();
    }
  }, [
    SCROLL_DIRECTION.UP,
    SCROLL_BEHAVIOR.OSCILLATE,
    SCROLL_BEHAVIOR.UP,
    scrollHandler,
    scrollBehavior,
    speed,
  ]);

  return (
    <AutoScrollContainer {...rest} ref={autoScrollRef}>
      <InView
        root={autoScrollRef.current}
        as="div"
        initialInView
        onChange={(inView) => {
          if (inView) onUpperBoundryIntersection();
        }}
      />
      {children}
      <InView
        root={autoScrollRef.current}
        as="div"
        onChange={(inView) => {
          if (inView) onLowerBoundryIntersection();
        }}
      />
    </AutoScrollContainer>
  );
};

AutoScroll.SCROLL_BEHAVIOR = SCROLL_BEHAVIOR;

AutoScroll.propTypes = {
  scrollBehavior: PropTypes.oneOf(Object.values(SCROLL_BEHAVIOR)),
  speed: PropTypes.number,
  children: PropTypes.node.isRequired,
};

AutoScroll.defaultProps = {
  scrollBehavior: SCROLL_BEHAVIOR.DOWN,
  speed: 10,
};
